const apiUrl = process.env.REACT_APP_API_URL;
export const GetContactes = async ( page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/contactes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
